export const getErrorModalType = type => type.concat('_ERROR');
